"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADJUSTMENT = exports.PAYMENT = exports.LIABILITY = exports.CREDIT = void 0;
exports.CREDIT = 'Credit';
exports.LIABILITY = 'Liability';
exports.PAYMENT = 'Payment';
exports.ADJUSTMENT = 'Adjustment';
